import { useAppDispatch } from '../../redux/hooks'
import { toggleAppShowFilterMenu, toggleAppShowSearchMenu } from '../../redux/reducers/searchSlice'
import './style.scss'

function HeaderAppLessons() {

	const dispatch = useAppDispatch()

	const searchButtonClickHandler = () => {
		dispatch(toggleAppShowSearchMenu())
	}
	const filterButtonClickHandler = () => {
		dispatch(toggleAppShowFilterMenu())
	}

	return (
		<div className="header-app-explore-wrap">
			<div className="header-app-explore-wrap-inner">
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-bell-button.svg'}
						className='header-app-header-button-img'
						alt='Bell Button'
					/>
				</div>
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/explore/header-text-lessons.svg'}
						className='header-app-header-button-img header-app-header-button-img-middle'
						alt='Lessons Text'
					/>
				</div>
				<div 
					className='header-app-header-button-wrap'
					onClick={() => {
						filterButtonClickHandler()
					}}
				>
					<img
						src={'/imgs/icons/explore/icon-explore-filter-button.svg'}
						className='header-app-header-button-img header-app-header-button-img-right'
						alt='Filter Button'
					/>
				</div>
			</div>
			<div className='header-app-header-buttons'>
				<div 
					className='header-app-header-button-round'
					onClick={() => {
						searchButtonClickHandler()
					}}
				>
					<img
						src={'/imgs/icons/explore/icon-search.svg'}
						className='header-app-header-search-img'
						alt='Search Icon'
					/>
					<div className='header-app-header-button-round-label'>
						Search
					</div>
				</div>
				
			</div>
		</div>
	)
}

export default HeaderAppLessons